import { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { NistGlossaryModal } from './NistGlossaryModal';

export const NetflixNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '#', active: true },
    { label: 'Experience', href: '#experience' },
    { label: 'Expertise', href: '#expertise' },
    { label: 'Projects', href: '#projects' },
    { label: 'Publications', href: '#publications' },
    { label: 'Awards', href: '#awards' },
    { label: 'Education', href: '#education' },
    { label: 'Gallery', href: '#gallery' }
  ];

  const scrollToSection = (href) => {
    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className={`netflix-nav fixed top-0 left-0 right-0 z-50 px-12 py-4 ${scrolled ? 'scrolled' : ''}`}>
        <div className="flex items-center justify-between">
          {/* Netflix Logo Style */}
          <div className="flex items-center space-x-8">
            <div className="netflix-logo cursor-pointer" onClick={() => scrollToSection('#')}>
              AKASH VERMA
            </div>
            
            {/* Navigation Links */}
            <div className="hidden lg:flex items-center space-x-6">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  className={`text-sm font-medium transition-colors hover:text-netflix-gray-300 ${
                    link.active ? 'text-white' : 'text-netflix-gray-400'
                  }`}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Right Side - Only Search */}
          <div className="flex items-center">
            <button 
              onClick={() => setShowSearch(true)}
              className="text-white hover:text-netflix-gray-300 transition-colors"
            >
              <Search className="w-5 h-5" />
            </button>
          </div>
        </div>
      </nav>
      
      {/* NIST Glossary Search Modal */}
      <NistGlossaryModal 
        isOpen={showSearch} 
        onClose={() => setShowSearch(false)} 
      />
    </>
  );
};